// assets
import loading from "assets/images/loading-state.gif";

const LoadingScreen = () => {
  return (
    <div className="loading-screen w-100 h-100 position-fixed start-0 top-0 d-flex justify-content-center align-items-center">
      <img src={loading} alt="" className="d-block img-fluid" />
    </div>
  );
};

export default LoadingScreen;
